<template>
  <Section
    decoration="/images/grid.svg"
    :index="6"
    :title="t('sections.talks')"
    id="talks"
  >
    <ul>
      <Litem
        v-for="talk in talks"
        :key="talk.title"
        border
        :link="talk.link"
        class="talks__item"
      >
        <template v-slot:presentation>
          <p class="talks__event">
            {{ talk.event }}
          </p>
          <p class="talks__date">
            {{ talk.date }}
          </p>
        </template>
        <template v-slot:content>
          <p class="talks__title">
            {{ talk.title }}
          </p>
          <p class="talks__description">
            {{ talk.description }}
          </p>
          <p class="talks__read">
            {{ t('read') }} →
          </p>
        </template>
      </Litem>
    </ul>
  </Section>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Litem from '@/ui/Litem.vue';
import Section from '@/ui/Section.vue';

type Talk = {
  title: string;
  event: string;
  date: string;
  link: string;
  description: string;
}

const { t, tm } = useI18n();

const talks = computed<Talk[]>(() => tm('talks'));
</script>

<style lang="scss" scoped>
@use '@/styles/mixins';
@use '@/styles/screens';

.talks__item:hover .talks__read {
  opacity: 0.8;
  transform: none;
  visibility: visible;
}

.talks__event,
.talks__date,
.talks__read {
  @include mixins.monotext;
}

.talks__date {
  color: var(--color-highlight);
  margin-top: 8px;
}

.talks__title {
  color: var(--color-text-strong);
  font-family: var(--font-family-display);
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 8px;
}

.talks__read {
  color: var(--color-highlight);
  margin-top: 12px;
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out, visibility 0.3s ease-in-out;
  visibility: hidden;
}
</style>
